import { Base } from '../base/index.js';
import { trapFocus, saveActiveElement, untrapFocus } from '@studiometa/js-toolkit/utils';

/**
 * Component's name.
 * @type {string}
 */
export const name = 'modal';

/**
 * Class Foo.
 */
export class Modal extends Base {
  /**
   * @type {import('../../types.d.ts').BaseConfig}
   */
  static config = {
    name,
  };

  isOpen = false;

  /**
   * connectedCallback
   */
  connectedCallback() {
    this.getElements();
  }

  /**
   * getElements
   */
  getElements() {
    this.closeBtn = this.querySelectorAll('.modal-close');

    this.closeBtn.forEach((el) => {
      el.addEventListener('click', this.close.bind(this));
    });

    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  /**
   * open
   */
  open() {
    this.setAttribute('aria-hidden', 'false');
    this.classList.add('is-open');
    this.isOpen = true;

    saveActiveElement();

    const focusTarget = this.querySelector('[autofocus]') ?? this.closeBtn[0] ?? this;
    if (focusTarget === this && !this.hasAttribute('tabindex')) {
      this.setAttribute('tabindex', '-1');
    }
    focusTarget.focus();
  }

  /**
   * close
   */
  close() {
    this.setAttribute('aria-hidden', 'true');
    this.classList.remove('is-open');
    this.isOpen = false;

    untrapFocus();
  }

  /**
   * @param {object} event
   * @param {string} event.key
   */
  onKeyup({ key }) {
    if (this.isOpen && key === 'Escape') {
      this.close();
    }
  }

  /**
   * @param {KeyboardEvent} event
   */
  onKeydown(event) {
    if (!this.isOpen) {
      return;
    }

    trapFocus(this, event);
  }
}

export default Modal;
